<script lang="ts" setup>
  import { LocationType, type ResultsLocation } from '~/core/types'

  const emit = defineEmits<{
    (e: 'close', v: ResultsLocation): void
  }>()

  const searchStore = useSearchStore()

  const {
    groups,
    noResult,
    debouncedHandleLocationInputSearch,
    activeSearchValue,
  } = useSearch()
  const { updateParams, locationLabel, filters } = useFilters()
  const router = useRouter()

  const { lastResultsItem } = storeToRefs(searchStore)

  const { displayToast } = useUiStore()
  const { t } = useI18n()

  const searchValueFieldIsActive = ref(false)
  const fetching = ref(false)
  const fetchingGeolocation = ref(false)

  const currentLocationLabel = computed(() => {
    if (!searchValueFieldIsActive.value) {
      return locationLabel.value
    }
    if (activeSearchValue.value === null) {
      return ''
    }
    return activeSearchValue.value
  })

  function handleLocationInputTyping(value: string) {
    activeSearchValue.value = value
    debouncedHandleLocationInputSearch(value)
  }

  function handleLocationInputBlur() {
    searchValueFieldIsActive.value = false
  }

  function resetAtClick() {
    if (searchValueFieldIsActive.value) {
      return
    }
    searchValueFieldIsActive.value = true
    activeSearchValue.value = ''
  }

  function handleLocationInputReset() {
    console.log('resetLocation')
  }

  function handleLocationInput(value: ResultsLocation) {
    if (value.type === LocationType.GOLF) {
      return router.push({ name: 'golf-golfSlug', params: { golfSlug: value.value.slug }, query: { date: filters.value.date, players: filters.value.players } })
    }
    emit('close', value)
    updateParams({ locationType: value.type, locationValue: resultsLocationValue(value) })
  }

  function handleCurrentLocationError() {
    displayToast(`Erreur lors de la geolocalisation`, 'error', 2000)
  }
</script>

<template>
  <div class="c-autocomplete-location">
    <Loader :displayed="fetchingGeolocation" />
    <p class="title">
      <span>Localité</span>
    </p>
    <InputBase
      icon="location"
      :model-value="currentLocationLabel"
      :placeholder="`${t('common.where')} ?`"
      name="where"
      :resetable="true"
      @click="resetAtClick"
      @update:model-value="handleLocationInputTyping"
      @reset="handleLocationInputReset"
      @blur="handleLocationInputBlur"
    />
    <ClientOnly>
      <InputLocation
        :loading="fetching"
        :no-result="noResult"
        :active-search="!!activeSearchValue"
        :groups="groups"
        :last-results="lastResultsItem"
        @input="handleLocationInput"
        @current-location-error="handleCurrentLocationError"
      />
    </ClientOnly>
  </div>
</template>

<style scoped>
.c-autocomplete-location {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 100%;
  flex: 1 0 auto;
  flex-direction: column;
  overflow-y: auto;

  .title {
    margin: 1.5em;

    span {
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 1.125em;
      font-weight: bold;
      opacity: 0.4;
    }
  }

  .c-input {
    margin: 1em 1.5em;
  }

  .c-loader {
    display: flex;
    height: 100%;
    opacity: 0.5;
  }
}
</style>
